import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import { SearchPage } from 'designsystem/components/5-templates/SearchPage';
import { TopBannerFeature } from 'features/Modules/TopBanner';

export const SearchPageFeature: React.FC<Content.SearchPage> = ({ properties, additionalTop, additionalPageContent }) => {
	const dictionary = useDictionaryContext();

	return (
		<SearchPage
			additionalTop={additionalTop}
			additionalPageContent={additionalPageContent}
			heading={properties?.heading}
			searchText={dictionary.getSearch('Search')}
			topBanner={properties?.bannerContent?.items?.length > 0 && <TopBannerFeature {...properties} />}
		/>
	);
};
